export enum NotebookShareScope {
    EntireNotebook = 1,
    SelectPages = 2,
    IndividualPage = 3,
}
